// src/components/Groups/GroupCard.jsx
import React from 'react';
import { Users, Globe, Lock, EyeOff, LogIn, Clock } from 'lucide-react';


const VISIBILITY_ICONS = {
  public:  <Globe  size={13} />,
  private: <Lock   size={13} />,
  secret:  <EyeOff size={13} />,
};

const GroupCard = ({ group, onClick, onJoin }) => {
  const joinStatus = group.join_status; // 'active' | 'pending' | null

  return (
    <div
      className="group-card"
      onClick={() => onClick(group)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && onClick(group)}
    >
      {/* Avatar */}
      <div className="group-card__avatar">
        {group.avatar ? (
          <img src={group.avatar} alt={group.name} />
        ) : (
          <div className="group-card__avatar-placeholder">
            {group.name.charAt(0).toUpperCase()}
          </div>
        )}
      </div>

      {/* Body */}
      <div className="group-card__body">
        <h3 className="group-card__name">{group.name}</h3>
        {group.description && (
          <p className="group-card__desc">{group.description}</p>
        )}
        <div className="group-card__meta">
          <span className="group-card__visibility">
            {VISIBILITY_ICONS[group.visibility]}
            {group.visibility}
          </span>
          <span className="group-card__members">
            <Users size={12} /> {group.members_count}
          </span>
          {group.user_role && (
            <span className={`role-badge role-badge--${group.user_role}`}>
              {group.user_role}
            </span>
          )}
        </div>
      </div>

      {/* Join button — only for public groups the user hasn't joined */}
      {onJoin && !group.is_member && (
        <div className="group-card__action" onClick={(e) => e.stopPropagation()}>
          {joinStatus === 'pending' ? (
            <span className="group-card__pending-badge">
              <Clock size={13} /> Pending
            </span>
          ) : (
            <button
              className="btn btn--primary btn--sm"
              onClick={(e) => onJoin(group, e)}
            >
              <LogIn size={13} /> Join
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default GroupCard;
